import type { ReactNode } from "react";

/** 二次确认弹窗顶部的一段说明：写清这次操作会发生什么、是否进审计。三个确认弹窗共用，样式只在这里定。 */
export function ConfirmNote({ children }: { children: ReactNode }) {
  return <p className="ax-secondary" style={{ margin: 0, fontSize: 13, lineHeight: "18px" }}>{children}</p>;
}
